import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueLayers from 'vuelayers'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

import 'vuelayers/lib/style.css' // needs css-loader
Vue.use(VueLayers)
Vue.use(VueAxios, axios)
Vue.config.productionTip = true

Sentry.init({
  Vue,
  dsn: "https://7b7c5a4775974d558f28f6138b9462f9@o925539.ingest.sentry.io/5874569",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

new Vue({
  mode: 'history',
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
